import type { FC } from "react";

import { Typography } from "@aviary";

import { subtitle as subtitleStyles } from "./SignUpModalSubtitle.styles";

interface Props {
  subtitle: string;
}

const SignUpModalSubtitle: FC<Props> = ({ subtitle }) => {
  return (
    <Typography type="body" css={subtitleStyles}>
      {subtitle}
    </Typography>
  );
};

export { SignUpModalSubtitle };
